"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findAdjacentDocs = exports.findSitemapItem = exports.SITEMAP = void 0;
// webpack.config.js가 ts-node로 직접 로드하므로 @/ alias 대신 상대경로를 유지한다.
const icon_names_1 = require("./components/common/icon/icon-names");
exports.SITEMAP = [
    // 1. 상단 독립 메뉴 (Top-level Links)
    {
        type: 'standalone',
        id: 'index',
        title: '홈',
        icon: icon_names_1.ICON_NAMES.HOME_PAGE,
    },
    {
        type: 'standalone',
        id: 'foundations',
        title: 'Foundations',
        icon: icon_names_1.ICON_NAMES.BOOK,
        children: [
            { id: 'foundations', name: 'Overview' },
            { id: 'layout', name: 'Layout' },
            { id: 'interaction', name: 'Interaction' },
            { id: 'pattern', name: 'Pattern' },
            { id: 'content', name: 'Content' },
        ],
    },
    {
        type: 'standalone',
        id: 'tokens',
        title: 'Tokens',
        icon: icon_names_1.ICON_NAMES.PALETTE,
    },
    // 2. 접고 펼치는 메뉴 그룹
    {
        type: 'group',
        id: 'visual-information',
        title: 'Visual Information',
        icon: icon_names_1.ICON_NAMES.FLOWER,
        items: [
            { id: 'avatar', name: 'Avatar' },
            { id: 'dot', name: 'Dot' },
            { id: 'text', name: 'Text' },
            { id: 'tag', name: 'Tag' },
            { id: 'thumbnail', name: 'Thumbnail' },
        ],
    },
    {
        type: 'group',
        id: 'structures',
        title: 'Structures',
        icon: icon_names_1.ICON_NAMES.BOX,
        items: [
            { id: 'surface', name: 'Surface' },
            { id: 'separator', name: 'Separator' },
            { id: 'list-item', name: 'List Item' },
            { id: 'table', name: 'Table' },
        ],
    },
    {
        type: 'group',
        id: 'overlays',
        title: 'Overlays',
        icon: icon_names_1.ICON_NAMES.COMMENT,
        items: [
            { id: 'tooltip', name: 'Tooltip' },
            { id: 'popover', name: 'Popover', badge: 'pattern' },
            { id: 'select', name: 'Select' },
            { id: 'sheet', name: 'Sheet', badge: 'pattern' },
            { id: 'dialog', name: 'Dialog' },
            { id: 'toast', name: 'Toast' },
        ],
    },
    {
        type: 'group',
        id: 'actions',
        title: 'Actions',
        icon: icon_names_1.ICON_NAMES.MOUSE_BUTTON,
        items: [
            { id: 'button', name: 'Button' },
            { id: 'icon-button', name: 'Icon Button' },
            { id: 'toggle-button', name: 'Toggle Button' },
            { id: 'menu-item', name: 'Menu Item' },
            { id: 'link', name: 'Link' },
        ],
    },
    {
        type: 'group',
        id: 'navigations',
        title: 'Navigations',
        icon: icon_names_1.ICON_NAMES.MENU,
        items: [
            { id: 'tabs', name: 'Tabs' },
            { id: 'top-bar', name: 'Top Bar' },
            { id: 'bottom-bar', name: 'Bottom Bar' },
            { id: 'breadcrumb', name: 'Breadcrumb', badge: '' },
            { id: 'step', name: 'Step' },
        ],
    },
    {
        type: 'group',
        id: 'forms',
        title: 'Forms',
        icon: icon_names_1.ICON_NAMES.DOCUMENT_CHECK,
        items: [
            { id: 'checkbox', name: 'Checkbox' },
            { id: 'radio', name: 'Radio' },
            { id: 'switch', name: 'Switch' },
            { id: 'input', name: 'Input' },
            { id: 'textarea', name: 'Textarea' },
            { id: 'file-uploader', name: 'File Uploader' },
        ],
    },
    {
        type: 'group',
        id: 'feedbacks',
        title: 'Feedbacks',
        icon: icon_names_1.ICON_NAMES.NOTIFICATION,
        items: [
            { id: 'notice', name: 'Notice' },
            { id: 'loading', name: 'Loading' },
            { id: 'result', name: 'Result' },
        ],
    },
    {
        type: 'group',
        id: 'patterns',
        title: 'Pages',
        icon: icon_names_1.ICON_NAMES.DOCUMENT,
        items: [
            { id: 'profile', name: 'User Profile', badge: '🔥' },
            { id: 'setting', name: 'Setting', hideNavbar: true },
            { id: 'class', name: 'Product 3 - Class' },
            { id: 'cake', name: 'Movie Detail' },
            { id: 'chat', name: 'Chat' },
            { id: 'dashboard', name: 'Dashboard' },
            { id: 'product', name: 'Product' },
            { id: 'auth', name: 'Auth' },
            { id: 'post', name: 'Post' },
            { id: 'post-detail', name: 'Post Detail' },
            { id: 'checkout', name: 'Checkout', hideNavbar: true },
            { id: 'pricing', name: 'Pricing' },
            { id: 'faq', name: 'FAQ' },
            { id: 'contact', name: 'Contact' },
        ],
    },
];
const findSitemapItem = (id) => {
    for (const node of exports.SITEMAP) {
        const items = node.type === 'group' ? node.items : node.children ?? [];
        const item = items.find(item => item.id === id);
        if (item)
            return item;
    }
    return undefined;
};
exports.findSitemapItem = findSitemapItem;
/** 문서 페이지의 읽기 순서. 홈과 패턴 예시(Pages)는 문서 흐름에서 제외한다. */
const DOC_SEQUENCE = exports.SITEMAP.flatMap(node => {
    if (node.type === 'group')
        return node.id === 'patterns' ? [] : node.items;
    if (node.id === 'index')
        return [];
    return node.children ?? [{ id: node.id, name: node.title }];
});
const findAdjacentDocs = (id) => {
    const index = DOC_SEQUENCE.findIndex(item => item.id === id);
    if (index < 0)
        return {};
    return { previous: DOC_SEQUENCE[index - 1], next: DOC_SEQUENCE[index + 1] };
};
exports.findAdjacentDocs = findAdjacentDocs;
//# sourceMappingURL=data:application/json;base64,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